



















import { Component, Vue, Prop } from 'vue-property-decorator';
import { TagSet } from '@/interfaces/registration/tags/TagSet';
import { Tag } from '@/interfaces/registration/tags/Tag';
import { ListOption } from '@/interfaces/registration/ListOption';
import { TagSetModel } from '@/interfaces/registration/models/TagSetModel';

@Component
export default class TagSetDropDownPicker extends Vue {
  @Prop() readonly tagSet!: TagSet;
  @Prop({ default: () => { return {}; } }) readonly value!: TagSetModel;

  get model (): { selectedParentTagId: string; selectedSubTagId: string } {
    const parentTagId = this.value && this.value.tags.length > 0 ? this.value.tags[0].toString() : '';
    const subTagId = this.value && this.value.tags.length > 1 ? this.value.tags[1].toString() : '';

    return {
      selectedParentTagId: parentTagId,
      selectedSubTagId: subTagId
    };
  }

  public parentTagChanged () {
    if (this.model.selectedParentTagId !== undefined && this.model.selectedParentTagId !== '') {
      this.$emit('input', { name: this.value.name, tags: [parseInt(this.model.selectedParentTagId)] });
    } else {
      this.$emit('input', { name: this.value.name, tags: [] });
    }
  }

  public subTagChanged () {
    if (this.model.selectedSubTagId !== undefined && this.model.selectedSubTagId !== '') {
      this.$emit('input', { name: this.value.name, tags: [parseInt(this.model.selectedParentTagId), parseInt(this.model.selectedSubTagId)] });
    } else {
      this.$emit('input', { name: this.value.name, tags: [parseInt(this.model.selectedParentTagId)] });
    }
  }

  get parentTagOptions (): Array<ListOption> {
    return this.tagSet.parentTags.map((value) => {
      return {
        value: value.id?.toString(),
        text: value.name
      };
    });
  }

  get subTagOptions (): Array<ListOption> {
    if (this.selectedParentTag !== undefined) {
      return this.selectedParentTag.subTags.map((value) => {
        return {
          value: value.id?.toString(),
          text: value.name
        };
      });
    }
    return [];
  }

  get selectedParentTag (): Tag | undefined {
    if (this.model.selectedParentTagId !== undefined && this.model.selectedParentTagId !== '') {
      return this.tagSet.parentTags.find((value) => value.id?.toString() === this.model.selectedParentTagId);
    }

    return undefined;
  }
}
